<template>
        <div class="container">
            <h6>
                {{guideInfo.title}}
            </h6>
            <div> 
                <p>
                    {{guideInfo.summary}}
                </p>
                <Button class="nav-button" type="button" @click="showGuide()">
                    <i class="pi pi-angle-right" style="font-size: 2rem" ></i>
                </Button>
            </div>
        </div>
    <Dialog
        v-model:visible="visibility"
        :dismissableMask="true" 
        :modal="true" 
        :show-header="false"
        :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
        <div v-html="markdownToHtml()"></div>
    </Dialog>
</template>
<script>
import { marked } from "marked";
export default {
  props: {
    guideInfo: null,
  },
  data() {
    return {
      visibility: false,
    };
  },
  methods: {
    showGuide() {
      this.visibility = true;
    },
    markdownToHtml() {
      return marked(this.guideInfo.content);
    },
  },
};
</script>
<style scoped>
h6 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

p {
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  width: 88%;
}

.container {
  background: #f0f2f4;
  border-radius: 10px;
  margin-bottom: 1rem;
  padding: 1rem;
}
.nav-button {
  width: 48px;
  height: 48px;
}
</style>
